import { axiosInstance, axiosInstanceUnauth } from "./setup/axiosInstance";
import ENDPOINTS from "./setup/constants";

const getBoundingMediaPoints = async (bounds) => {
	return axiosInstanceUnauth.get(
		`${ENDPOINTS.media}?lat_min=${bounds.south}&long_min=${bounds.west}&lat_max=${bounds.north}&long_max=${bounds.east}`
		, {
			headers: {
				'Content-Type': 'application/json'
			}
		}).then((res) => {
			return res.data;
		}).catch((error) => {
			console.error('Request Failed:', error.config);
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}

			return Promise.reject(error.response || error.message);
		})
};

const getBoundingMediaPointsAuth = async (bounds, token) => {
	return axiosInstanceUnauth.get(
		`${ENDPOINTS.media}/auth?lat_min=${bounds.south}&long_min=${bounds.west}&lat_max=${bounds.north}&long_max=${bounds.east}`
		, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${token}`
			}
		}).then((res) => {
			return res.data;
		}).catch((error) => {
			console.error('Request Failed:', error.config);
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}

			return Promise.reject(error.response || error.message);
		})
};

const getMyMedia = async (token) => {
	return axiosInstanceUnauth.get((ENDPOINTS.media + "/my"), {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => {
			return res.data;
		}).catch((error) => {
			console.error('Request Failed:', error.config);
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}

			return Promise.reject(error.response || error.message);
		})
};

const getFavorites = async (token) => {
	return axiosInstanceUnauth.get((ENDPOINTS.media + "/favorites"), {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => {
			return res.data;
		}).catch((error) => {
			console.error('Request Failed:', error.config);
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}

			return Promise.reject(error.response || error.message);
		})
};

const addFavorite = (mediaId, token) => {
	return axiosInstanceUnauth.post(`${ENDPOINTS.media}/${mediaId}/favorite`, null, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => {
			if (res.data.status !== 'OK') {
				return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
			}
			return res.data;
		})
		.catch((error) => {
			console.error('Request Failed:', error.config || 'No config');
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}
			return Promise.reject(error.response || error.message);
		});
};

const removeFavorite = (mediaId, token) => {
	return axiosInstanceUnauth.delete(`${ENDPOINTS.media}/${mediaId}/favorite`, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => {
			if (res.data.status !== 'OK') {
				return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
			}
			return res.data;
		})
		.catch((error) => {
			console.error('Request Failed:', error.config || 'No config');
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}
			return Promise.reject(error.response || error.message);
		});
};

const likeMedia = (mediaId, token) => {
	return axiosInstanceUnauth.post(`${ENDPOINTS.media}/${mediaId}/like`, null, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => {
			if (res.data.status !== 'OK') {
				return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
			}
			return res.data;
		})
		.catch((error) => {
			console.error('Request Failed (likeMedia):', error.config || 'No config');
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
			} else {
				console.error('Error Message:', error.message);
			}
			return Promise.reject(error.response || error.message);
		});
};

const unlikeMedia = (mediaId, token) => {
	return axiosInstanceUnauth.delete(`${ENDPOINTS.media}/${mediaId}/like`, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => {
			if (res.data.status !== 'OK') {
				return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
			}
			return res.data;
		})
		.catch((error) => {
			console.error('Request Failed (unlikeMedia):', error.config || 'No config');
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
			} else {
				console.error('Error Message:', error.message);
			}
			return Promise.reject(error.response || error.message);
		});
};

const deleteMedia = (mediaId, token) => {
	return axiosInstanceUnauth.delete(`${ENDPOINTS.media}/${mediaId}`, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
		}
	})
		.then((res) => {
			if (res.data.status !== 'OK') {
				return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
			}
			return res.data;
		})
		.catch((error) => {
			console.error('Request Failed (deleteMedia):', error.config || 'No config');
			if (error.response) {
				console.error('Status:', error.response.status);
				console.error('Data:', error.response.data);
			} else {
				console.error('Error Message:', error.message);
			}
			return Promise.reject(error.response || error.message);
		});
};


const getReportedMedia = async (token) => {
	return axiosInstanceUnauth.get(`${ENDPOINTS.media}/admin/reports`, {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	}).then(res => res.data);
};

const reportMedia = async (mediaId, reason, token) => {
	return axiosInstance.post(`${ENDPOINTS.media}/${mediaId}/report`, { reason }, {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	}).then(res => {
		if (res.data.status !== 'OK') {
			return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
		}
		return res.data;
	});
};

const blockMedia = async (mediaId, token) => {
	return axiosInstance.post(`${ENDPOINTS.media}/admin/${mediaId}/block`, {}, {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	}).then(res => {
		if (res.data.status !== 'OK') {
			return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
		}
		return res.data;
	});
};

const unblockMedia = async (mediaId, token) => {
	return axiosInstance.post(`${ENDPOINTS.media}/admin/${mediaId}/unblock`, {}, {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	}).then(res => {
		if (res.data.status !== 'OK') {
			return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
		}
		return res.data;
	});
};

const blockUser = async (userId, blockVideos, token) => {
	return axiosInstance.post(`${ENDPOINTS.accounts}/admin/${userId}/block`, { blockVideos }, {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	}).then(res => {
		if (res.data.status !== 'OK') {
			return Promise.reject({ response: res, message: `Server returned an error: ${res.data.error}` });
		}
		return res.data;
	});
};


const mediaAPI = {
	getBoundingMediaPoints,
	getBoundingMediaPointsAuth,
	getMyMedia,
	getFavorites,
	addFavorite,
	removeFavorite,
	likeMedia,
	unlikeMedia,
	deleteMedia,
	getReportedMedia,
	reportMedia,
	blockMedia,
	unblockMedia,
	blockUser
}

export default mediaAPI;